import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { GetActiveBanners } from 'src/graphql/banners';

const ActiveBannersContext = createContext({
  banners: [],
  fetching: false,
  reexecute: () => {},
});

export function ActiveBannersProvider({ children }) {
  const { data, fetching, reexecuteQuery } = GetActiveBanners();

  useEffect(() => {
    const refresh = () => reexecuteQuery({ requestPolicy: 'network-only' });
    const onVisibility = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [reexecuteQuery]);

  const value = useMemo(() => ({
    banners: data?.activeBanners || [],
    fetching,
    reexecute: reexecuteQuery,
  }), [data?.activeBanners, fetching, reexecuteQuery]);

  return (
    <ActiveBannersContext.Provider value={value}>
      {children}
    </ActiveBannersContext.Provider>
  );
}

export const useActiveBanners = () => useContext(ActiveBannersContext);

export default ActiveBannersContext;
